﻿import React, { useState, useEffect } from "react";
import { FETCH_SITE_TYPES, SAVE_USER_SITES_PROJECTS } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import {
  Box,
  Card,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Modal,
  Stack,
  Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { English } from "../../constant/EnglishFallback";

const AddProjectTypeModal = ({ open, onClose, onDataSave, projectDetails }) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;

  const [typeList, setTypeList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const {
    TEXT_CHOOSE_PROJECT_TYPE = English?.AddProjectTypeModal?.TEXT_CHOOSE_PROJECT_TYPE,
    TEXT_PLACEHOLDER_NO_DATA = English?.AddProjectTypeModal?.TEXT_PLACEHOLDER_NO_DATA
  } = multiLanguageData?.AddProjectTypeModal || {};

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    try {
      let getObj = {
        PageNr: 1,
        NrOfRecPerPage: 0,
        FullSearch: "",
        UserId: currentUserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [{}],
        SortList: [{ FieldName: "Name", Direction: "ASC" }]
      };
      let siteTypeRes = await Postrequestcall(FETCH_SITE_TYPES, getObj, loginData?.accessToken);
      let siteTypeResData = siteTypeRes?.data?.data ?? [];
      setTypeList(siteTypeResData ?? []);
    } catch (error) {
      console.log("getData-> Error Fetching Sites Type: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave = async (item) => {
    try {
      setIsLoading(true);
      const obj = {
        UserId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: projectDetails?.id,
            UserId: Number(currentUserId),
            SiteId: projectDetails?.siteId,
            projectName: projectDetails?.projectName,
            ProjectType: item,
            ProjectWebsite: projectDetails?.projectWebsite,
            Description: projectDetails?.description,
            IsActive: projectDetails?.isActive,
            RecordStatusId: 1,
            ModifiedBy: Number(currentUserId)
          }
        ]
      };
      await Postrequestcall(SAVE_USER_SITES_PROJECTS, obj, loginData?.accessToken);
      onDataSave();
      onClose();
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log("handleSave-> Error Saving User Sites Project: ", err);
    }
  };

  return (
    <Modal open={open}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6" sx={{ ml: 1 }}>
            {TEXT_CHOOSE_PROJECT_TYPE}
          </Typography>
          <Stack direction={"row"}>
            <IconButton onClick={() => onClose()}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </Box>
        <Box className="product-list" sx={{ marginTop: "10px" }}>
          {isLoading ? (
            <Loader />
          ) : (
            <List disablePadding>
              {typeList.length > 0 ? (
                <Stack sx={{ gap: 1 }} >
                  {typeList.map((item, index) => {
                    return (
                      <Card key={index.toString()} className="pagelist-content">
                        <ListItem key={index.toString()} disablePadding>
                          <ListItemButton onClick={() => handleSave(item?.id)}>
                            <ListItemText>{item?.name?.trim()}</ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Card>
                    );
                  })}
                </Stack>
              ) : (
                <Typography>{TEXT_PLACEHOLDER_NO_DATA}</Typography>
              )}
            </List>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default AddProjectTypeModal;

